export default __webpack_public_path__ + "static/media/mobile-about.36ca025a.webm";